import React from "react";
import {css} from "@emotion/react";

import {mb} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {ShowMoreButton} from "../../../atoms/ShowMoreButton";
import {IParkingPlace} from "../../../property/interfaces/IParkingPlace";
import {IRangeQuery} from "../../../request/IRangeQuery";
import {Currency} from "../../../types/Currency";
import {VendorType} from "../../../vendor/helpers/VendorType";
import {OfferType} from "../../types/OfferType";
import {IRoomRange, OfferDetailGeneratedDescription} from "./OfferDetailGeneratedDescription";

interface IProps {
    className?: string;
    offer: {
        currency: Currency;
        buildings: number;
        configuration: {
            show_generated_description: boolean;
        };
        construction_date_range: IRangeQuery<string>;
        description: string | null;
        floors_above_ground_range: IRangeQuery<number> | null;
        floors_below_ground: number | null;
        investor: string | null;
        is_holiday_location: boolean;
        is_condohotel: boolean;
        logo: {
            o_log_200: string;
        } | null;
        name: string;
        parking_places: IParkingPlace[];
        properties: number;
        region: {
            name_declension_where: string;
        };
        stats: {
            all_flat_types: Record<string, number>;
            all_house_types: Record<string, number>;
            distance_from_region: {
                center: boolean;
                region: string;
                distance: number;
            };
            properties_count_for_sale: number;
            properties_count_mdm: number;
            properties_with_roi_count: number;
            ranges_area_min: number;
            ranges_area_max: number;
            ranges_price_m2_min: number;
            ranges_price_m2_max: number;
            ranges_price_min: number;
            rooms_ranges: IRoomRange[];
        } | null;
        storage: {
            quantity: number;
            description: string;
            price: number;
        };
        street_name: string;
        street_number: string | null;
        type: OfferType;
        vendor: {
            type: VendorType;
            name: string;
        };
    };
}

export const preLineDescription = (description: string, additionalEl?: React.JSX.Element) => {
    return description.split("\n").map((item, key) => (
        <Text key={key} variant="body_copy_1" mb={2}>
            {item.trim()}
            {additionalEl}
        </Text>
    ));
};

export const OfferDetailDescription = (props: IProps) => {
    const {offer} = props;

    return (
        <>
            <Text variant="headline_4" as="h2" css={mb(2)}>
                Opis inwestycji
            </Text>

            <Text as="div" variant="body_copy_1" css={offerDescriptionStyles}>
                {offer.logo && <img src={offer.logo.o_log_200} alt={`${offer.name} logo`} css={logoStyles} />}

                {offer.description ? (
                    <>
                        <div>{preLineDescription(offer.description)}</div>
                        {offer.configuration.show_generated_description && (
                            <ShowMoreButton dataGtmClick="Czytaj więcej - opis inwestycji" preventShowLess>
                                <OfferDetailGeneratedDescription offer={offer} />
                            </ShowMoreButton>
                        )}
                    </>
                ) : (
                    <OfferDetailGeneratedDescription offer={offer} />
                )}
            </Text>
        </>
    );
};

const logoStyles = css`
    display: block;
    margin-bottom: 2rem;
`;

const offerDescriptionStyles = css`
    margin-bottom: 1.4rem;
`;

export const offerDetailDescriptionSubheading = css`
    padding-top: 2rem;
`;
import React from "react";
import {css} from "@emotion/react";

import {mb} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {ShowMoreButton} from "../../../atoms/ShowMoreButton";
import {IParkingPlace} from "../../../property/interfaces/IParkingPlace";
import {IRangeQuery} from "../../../request/IRangeQuery";
import {Currency} from "../../../types/Currency";
import {VendorType} from "../../../vendor/helpers/VendorType";
import {OfferType} from "../../types/OfferType";
import {IRoomRange, OfferDetailGeneratedDescription} from "./OfferDetailGeneratedDescription";

interface IProps {
    className?: string;
    offer: {
        currency: Currency;
        buildings: number;
        configuration: {
            show_generated_description: boolean;
        };
        construction_date_range: IRangeQuery<string>;
        description: string | null;
        floors_above_ground_range: IRangeQuery<number> | null;
        floors_below_ground: number | null;
        investor: string | null;
        is_holiday_location: boolean;
        is_condohotel: boolean;
        logo: {
            o_log_200: string;
        } | null;
        name: string;
        parking_places: IParkingPlace[];
        properties: number;
        region: {
            name_declension_where: string;
        };
        stats: {
            all_flat_types: Record<string, number>;
            all_house_types: Record<string, number>;
            distance_from_region: {
                center: boolean;
                region: string;
                distance: number;
            };
            properties_count_for_sale: number;
            properties_count_mdm: number;
            properties_with_roi_count: number;
            ranges_area_min: number;
            ranges_area_max: number;
            ranges_price_m2_min: number;
            ranges_price_m2_max: number;
            ranges_price_min: number;
            rooms_ranges: IRoomRange[];
        } | null;
        storage: {
            quantity: number;
            description: string;
            price: number;
        };
        street_name: string;
        street_number: string | null;
        type: OfferType;
        vendor: {
            type: VendorType;
            name: string;
        };
    };
}

export const preLineDescription = (description: string, additionalEl?: React.JSX.Element) => {
    return description.split("\n").map((item, key) => (
        <Text key={key} variant="body_copy_1" mb={2}>
            {item.trim()}
            {additionalEl}
        </Text>
    ));
};

export const OfferDetailDescription = (props: IProps) => {
    const {offer} = props;

    return (
        <>
            <Text variant="headline_4" as="h2" css={mb(2)}>
                Opis inwestycji
            </Text>

            <Text as="div" variant="body_copy_1" css={offerDescriptionStyles}>
                {offer.logo && <img src={offer.logo.o_log_200} alt={`${offer.name} logo`} css={logoStyles} />}

                {offer.description ? (
                    <>
                        <div>{preLineDescription(offer.description)}</div>
                        {offer.configuration.show_generated_description && (
                            <ShowMoreButton dataGtmClick="Czytaj więcej - opis inwestycji" preventShowLess>
                                <OfferDetailGeneratedDescription offer={offer} />
                            </ShowMoreButton>
                        )}
                    </>
                ) : (
                    <OfferDetailGeneratedDescription offer={offer} />
                )}
            </Text>
        </>
    );
};

const logoStyles = css`
    display: block;
    margin-bottom: 2rem;
`;

const offerDescriptionStyles = css`
    margin-bottom: 1.4rem;
`;

export const offerDetailDescriptionSubheading = css`
    padding-top: 2rem;
`;
